import { Component, OnInit, Input, Output, ElementRef, ViewChild, EventEmitter } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR, FormBuilder, Validators } from '@angular/forms';
import { Currency, PaymentTypes } from '@app/driver-tariffs/tariff';

@Component({
  selector: 'currency-select',
  templateUrl: './currency-select.component.html',
  styleUrls: ['./currency-select.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CurrencySelectComponent, multi: true }]
})
export class CurrencySelectComponent implements OnInit, ControlValueAccessor {

  @Input() title;

  touched = [];
  changed = [];

  func;

  currencyForm: FormGroup;

  private currencyObj: Currency;

  constructor(private fb: FormBuilder) { }

  @Input('disabled')
  set disabled(val) {
    this.func = val ? 'enable' : 'disable';
    if (this.currencyForm) {
      this.currencyForm.get('percent')[this.func]();
      this.currencyForm.get('natural')[this.func]();
      this.func = null;
    }
  }

  ngOnInit() {
    this.currencyObj = {
      value: 0,
      type: PaymentTypes.percent
    }
    this.currencyForm = this.fb.group({
      percent: '',
      natural: ''
    }, { validator: this.currencyValidator });
    if (this.func) {
      this.currencyForm.get('percent')[this.func]();
      this.currencyForm.get('natural')[this.func]();
      this.func = null;
    }
  }


  get value() {
    console.log(this.currencyForm.value);
    
    if (this.currencyForm.value.percent)
      return {
        value: this.currencyForm.value.percent,
        type: PaymentTypes.percent,
        isValid: this.currencyForm.get('percent').valid || this.currencyForm.disabled
      }

    else if (this.currencyForm.value.natural)
      return {
        value: this.currencyForm.value.natural,
        type: PaymentTypes.natural,
        isValid: this.currencyForm.get('natural').valid || this.currencyForm.disabled
      }

    return {
      value: 0,
      type: PaymentTypes.natural,
      isValid: false
    }

  }

  set value(value: Currency) {
    if (!value || !this.currencyForm) return;
    this.currencyObj = value;
    let natural = this.currencyForm.get('natural');
    let percent = this.currencyForm.get('percent');
    natural.setValue('');
    percent.setValue('');
    natural.markAsUntouched();
    percent.markAsUntouched();
    if (this.currencyForm.disabled) return;
    if (value.type == PaymentTypes.percent) 
      percent.setValue(this.currencyObj.value);
    if (value.type == PaymentTypes.natural)
      natural.setValue(this.currencyObj.value);
  }

  switch(type) {
    this.currencyForm.get(type).setValue('');
    this.currencyForm.get(type).markAsUntouched();
  }

  currencyValidator(group: FormGroup) {
    const checkCurrency = (arg) => {
      let num = Number(arg)
      return !isNaN(num) && num >= 0 && num <= 100;
    }

    let percent = group.get('percent');
    let natural = group.get('natural');

    if (natural.value == '' && percent.value == '') {
      natural.setErrors({ 'null_fields_error': true });
      percent.setErrors({ 'null_fields_error': true });
    }

    if (percent.value && !checkCurrency(percent.value))
      percent.setErrors({ 'invalid_value_error': true });

    if (natural.value && !checkCurrency(natural.value))
      natural.setErrors({ 'invalid_value_error': true });
    return null;
  }



  writeValue(obj: Currency): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.changed.push(fn);
  }

  registerOnTouched(fn: any): void {
    this.touched.push(fn);
  }

  touch() {
    this.touched.map(f => f());
  }

  input() {
    this.changed.map(f => f(this.value));
  }

}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/currency-select/currency-select.component.ts